import React, { useState, useEffect } from 'react'
import { Popover, Typography } from '@mui/material'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { RiChatHistoryLine } from 'react-icons/ri'
import { LuCalendarDays } from 'react-icons/lu'
import CustomDisputeRiskTable from '../../Common/ui/riskTable'
import { useRiskStore } from '../../Containers/Risk/Store/RiskStore'
import Loading from '../../Common/ui/Loading'
import * as RiskTypes from '../../Entities/RiskTypes'

const DisputeRisk = () => {
    const [ isModalOpen, setIsModalOpen ] = useState(false)
    const { RiskDisputeDataLoading, getRiskDispute } = useRiskStore()
    const RiskDisputeData = useRiskStore((state) => state.RiskDisputeData)
    let isInit = true
    const userId = localStorage.getItem('userId')
    useEffect(() => {
        if (isInit) {
            getRiskDispute(1, 10, userId)
            isInit = false
        }
    }, [])

    const openModal = () => {
        setIsModalOpen(true)
    }
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
    }

    const TableHeaders = RiskTypes?.DISPUTE_TABLE_HEADERS?.map((mapData) => {
        if (mapData?.field === RiskTypes.DOT) {
            return {
                ...mapData,
                renderCell: (params) => (
                    <div>
                        <BsThreeDotsVertical onClick={openModal} className='mt-3 '/>
                    </div>
                )
            }
        } else return mapData
    })

    return (
        <div className='h-[100%] p-6'>
            <Loading isLoading={RiskDisputeDataLoading} />
            <CustomDisputeRiskTable tableHeaders={TableHeaders} tableBodyData={RiskDisputeData} />
            <Popover
                open={isModalOpen}
                onClose={toggleModal}
                className='p-2'
                anchorReference="anchorPosition"
                anchorPosition={{ top: 250, left: 1320 }}>
                {/* <div className='flex'><RiVideoAddLine className='m-3'/><Typography sx={{ p: 1 }}>Meeting </Typography></div> */}
                <div className='flex'><LuCalendarDays className='m-3'/><Typography sx={{ p: 1 }}>Set Reminder</Typography></div>
                <div className='flex'><RiChatHistoryLine className='m-3'/><Typography sx={{ p: 1 }}>Chat & Timeline </Typography></div>
            </Popover>
        </div>
    )
}

export default DisputeRisk
